import React from "react";
import { View, StyleSheet, Text } from "react-native";
import AssignmentSuggestionCardContainer from "../../containers/companion/AssignmentSuggestionCardContainer";
import CompanionDisclaimerText from "./CompanionDisclaimerText";

interface ChatEmptyStateProps {
  input: React.ReactNode;
  title?: string;
  onAssignmentPress?: (assignment: {
    id: string;
    title?: string | null;
    due_date?: string | null;
    courseName?: string;
    courseId?: string;
  }) => void;
}

const ChatEmptyState = ({ title, input, onAssignmentPress }: ChatEmptyStateProps) => {
  return (
    <View style={styles.container}>
      <View style={styles.content}>
        <View style={styles.emptyStateArea}>
          <View style={styles.emptyStateContent}>
            <Text style={styles.emptyStateTitle} aria-level="2" role="heading">
              Start a new thread
            </Text>
            <Text style={styles.emptyStateSubtitle} aria-level="3" role="heading">
              Type a message or attach a document to begin
            </Text>
            <View style={styles.chatInputArea}>{input}</View>
            <View style={styles.disclaimerContainer}>
              <CompanionDisclaimerText />
            </View>
            {onAssignmentPress && <AssignmentSuggestionCardContainer onAssignmentPress={onAssignmentPress} />}
          </View>
        </View>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
  },
  content: {
    flex: 1,
    display: "flex",
    flexDirection: "row",
    overflow: "hidden",
    justifyContent: "center",
  },
  emptyStateArea: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    backgroundColor: "#f9fafbb3",
    justifyContent: "center",
    alignItems: "center",
    maxWidth: 770,
  },
  emptyStateContent: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  emptyStateTitle: {
    fontSize: 24,
    lineHeight: 32,
    fontWeight: "600",
    color: "#1f2937",
    textAlign: "center",
    marginBottom: 8,
  },
  emptyStateSubtitle: {
    fontSize: 16,
    lineHeight: 24,
    fontWeight: "400",
    color: "#475467",
    textAlign: "center",
    marginBottom: 16,
  },
  chatInputArea: {
    flex: 1,
    width: "100%",
    padding: 16,
  },
  disclaimerContainer: {
    alignItems: "center",
  },
});

export default ChatEmptyState;
